import React from "react";
import { Form, Button } from "react-bootstrap";
import { Trans } from "react-i18next";

const PremiumDetails = (props) => {
  const {t} = props;
  const botName = "Market Neutral Bot"
  

  return (
    <ul> 
        <li>
          <img src="/images/sp-icon.svg" alt=""/>
          <span>15 {t("active-bots")}</span>
        </li>
        <li>
          <img src="/images/sp-icon.svg" alt=""/>
          <span> Quick Start, DCA, Advanced bots</span>
        </li>
        <li>
          <img src="/images/sp-icon.svg" alt=""/>
          <span> TradingView support</span>
        </li>
        <li>
          <img src="/images/sp-icon.svg" alt=""/>
          <span> Strategy Marketplace Access</span>
        </li>
        <li>
          <img src="/images/sp-icon.svg" alt=""/>
          <span> Support for <a href="https://www.tradestation.com/promo/stockhero" target="_blank"><font color="blue"> TradeStation (recommended),</font></a> Webull,E*Trade,Alpaca,Stake Australia and <a href="https://docs.stockhero.ai/connecting-brokerage/supported-brokerages">more..</a></span>
        </li>
        <li>
          <img src="/images/sp-icon.svg" alt=""/>
          <span> AI ChatBot</span>
        </li>
        <li>
          <img src="/images/sp-icon.svg" alt=""/>
          <span> Market Intelligence</span>
        </li>
        <li>
          <img src="/images/sp-icon.svg" alt=""/>
          <span> Newsfeed </span>
        </li>
        <li>
          <img src="/images/sp-icon.svg" alt=""/>
          <span> White Glove Service</span>
        </li>
       
    </ul>
  );
};

export default PremiumDetails;
